import { useState, useEffect, useRef, useCallback, Fragment, useMemo } from "react";
import style from "./AlbumItem.module.scss";
import { v4 } from "uuid";
import * as YStyled from "../../../Styleds";
import ImageLoader from "./ImageLoader";
/* link, name,isSelf */
const AlbumItem = ({ album, userData, onAdd, onEdit }) => {
    const isSelf = useRef(false);
    useEffect(() => {
        if (userData) {
            isSelf.current = userData.users_id === album.event_album_link_created_by_user.user_id;
        }
    }, [])
    return (
        <>
            {album ?
                <div className={style.albumBox}>
                    <div className={style.album} onClick={e => {
                        window.open(album.event_album_link_album_url, "_blank");
                    }}>
                        <div className={style.photo}>
                            <img src="./assets/ui/photo.png" />
                            <ImageLoader className={style.userIcon} variant={"circular"} style={{ width: "2rem", height: "2rem" }} src={album.event_album_link_created_by_user.user_avatar} />
                        </div>
                        <YStyled.Span size={15} fontWeight={400} fontFamily="SF Pro">{isSelf.current ? "你的相簿" : album.event_album_link_created_by_user.user_name}</YStyled.Span>
                    </div>
                    {isSelf.current &&
                        <YStyled.Span color="#007AFF" onClick={e => { onEdit() }} size={15} fontFamily="SF Pro" style={{ alignSelf: "center", marginTop: "5px" }}>編輯</YStyled.Span>
                    }
                </div>
                :
                <div className={style.add} onClick={e => { onAdd() }}>
                    <img src="./assets/ui/addLink.png" />
                    <YStyled.Span size={13} fontWeight={400} fontFamily="SF Pro">新增相簿連結</YStyled.Span>
                </div>
            }
        </>
    );
}

export default AlbumItem;